<div class="d-b field__datepicker" ngbDropdown #myDrop="ngbDropdown" autoClose="outside">
  <input
    type="text"
    placeholder="{{ placeholder }}"
    class="input-datepicker"
    [ngClass]="{
      'input-datepicker--invalid': validationError,
      'input-datepicker__value-exists': parseDate,
      'input-datepicker__value-empty': !parseDate
    }"
    [(ngModel)]="parseDate" [ngModelOptions]="{ standalone: true }"
    maxlength="{{ isShowTimepicker ? 16 : 10 }}"
    name="{{ datepickerName + 'Input' }}"
    id="{{ datepickerName }}"
    (input)="onDateTimePickerTypedChange($event)"
    (blur)="onDateTimePickerBlur($event)"
    fieldTrim
    [disabled]="isDisabled"
  />
  <div
    class="field__button"
    [ngClass]="{
      'field__button--double': parseDate,
      'field__button--one': !parseDate
    }"
  >
    <app-icon [glyph]="'hd-close-small'" [size]="'16'" (click)="onResetDate(); myDrop.close()" *ngIf="parseDate"></app-icon>
    <app-icon [glyph]="'hd-calendar'" [size]="'16'"></app-icon>
    <span class="input-datepicker-toggle" ngbDropdownToggle></span>
  </div>
  <div *ngIf="isDisabled" class="disabled-wrapper"></div>
  <ul class="dropdown-menu" style="width: 270px; overflow: hidden" ngbDropdownMenu>
    <li>
      <app-date-picker
        [startView]="'day'"
        [maxView]="'year'"
        [minView]="'day'"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [disabledTooltip]="disabledTooltip"
        [(ngModel)]="initDate" [ngModelOptions]="{ standalone: true }"
        (change)="onDatepickerChange($event); myDrop.close()"
      >
      </app-date-picker>
    </li>
    <li *ngIf="isShowTimepicker">
      <div class="time-picker__block">
        <div class="time-picker__block-content">
          <div><b class="color-blue-dark mr-8">Время</b></div>
          <app-time-picker [(ngModel)]="time" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onTimepickerChange($event)"></app-time-picker>
        </div>
      </div>
    </li>
    <li>
      <div class="grid mt-8 mb-4 pl-16 pr-16">
        <div class="grid__box grid__box--size-min grid__box--pull-left">
          <a class="link link--dotted-gray-dark" (click)="isAbonentCurrent ? setAbonentCurrent() : setCurrent()">Сейчас</a>
        </div>
        <div class="grid__box grid__box--size-min grid__box--pull-right">
          <a class="link link--dotted-gray-dark" (click)="myDrop.close()">Закрыть</a>
        </div>
      </div>
    </li>
  </ul>
</div>
